import { useUserStore } from "../../store/UserStore";

export const useUserHasPermission = (requiredRoles) => {
    const roles = useUserStore((state) => state.userRoles);
    return roles.some((role) => requiredRoles.includes(role));
};